import React from 'react';
import { ConversationMessageKey } from 'flow/types/TicketEventData';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectIsMostRecentEvent,
    selectMessageDeliveryStatus,
} from 'flow/selectors/TicketEventSelectors';
import { TicketKey } from 'flow/types/EntityKeys';
import { twMerge } from 'tailwind-merge';
import MessageStatus from './MessageStatus';

interface Props {
    messageKey: ConversationMessageKey;
    ticketKey: TicketKey;
    displayFailedAndSendingOnly?: boolean; // Specify if only failed and sending statuses should be shown
}

const DeliveryStatus = ({
    messageKey,
    ticketKey,
    displayFailedAndSendingOnly,
}: Props) => {
    const deliveryStatus = useAppSelector((state) =>
        selectMessageDeliveryStatus(state, ticketKey, messageKey),
    );

    const isMostRecentOutgoingMessage = useAppSelector((state) =>
        selectIsMostRecentEvent(state, ticketKey, messageKey),
    );

    if (
        !deliveryStatus ||
        (!isMostRecentOutgoingMessage && deliveryStatus !== 'FAILED')
    ) {
        return null;
        // Displaying status only for the most recent outgoing message or if it failed
    }

    const shouldDisplayMessageStatusText = displayFailedAndSendingOnly
        ? deliveryStatus === 'FAILED' || deliveryStatus === 'SENDING'
        : true;

    return shouldDisplayMessageStatusText ? (
        <div
            className={twMerge(
                'flex',
                deliveryStatus === 'FAILED' ? 'justify-end' : 'mt-1',
            )}
        >
            <MessageStatus
                status={deliveryStatus}
                ticketKey={ticketKey}
                messageKey={messageKey}
            />
        </div>
    ) : null;
};

export default DeliveryStatus;
